if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      this.modalContent.innerHTML = '';

      if (preventFocus) this.openedBy = null;
      super.hide();
    }

    show(opener) {
      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');
      opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      fetch(opener.getAttribute('data-product-url'))
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
          this.preventDuplicatedIDs();
          this.removeDOMElements();
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          if (window.ProductModel) window.ProductModel.loadShopifyXR();

          this.removeGalleryListSemantic();
          this.updateImageSizes();
          this.preventVariantURLSwitching();
          super.show(opener);
          var btnShareButton = document.querySelector('.js-btn-share');
          if(btnShareButton) {
            btnShareButton.addEventListener('click', function () {
              var shareWrap = document.querySelector('.js-product-share');
              if (shareWrap.classList.contains('is-active')) {
                shareWrap.classList.remove('is-active');
                shareWrap.style.maxHeight = null;
                btnShareButton.classList.remove('is-active');
              } else {
                shareWrap.classList.add('is-active');
                shareWrap.style.maxHeight = shareWrap.scrollHeight + "px";
                btnShareButton.classList.add('is-active');
              }
            });
          }
          /**
           * Initial arrow
           * @return {undefined}
           */
          function arrowGallery() {
            var svgURI = 'http://www.w3.org/2000/svg';
            var svg = document.createElementNS(svgURI, 'svg');
            svg.setAttribute('viewBox', '0 0 12 20');
            svg.setAttribute('width', '12');
            svg.setAttribute('fill', 'none');
            var path = document.createElementNS(svgURI, 'path');
            path.setAttribute('d', 'm2 2 8 8-8 8');
            path.setAttribute('fill', 'none');
            path.setAttribute('stroke', '#1F2931');
            path.setAttribute('stroke-linecap', 'round');
            path.setAttribute('stroke-width', '2.5');
            path.setAttribute('stroke-linejoin', 'round');
            svg.setAttribute('class', 'arrow__btn');
            svg.appendChild(path);
            return svg;
          }
          var gallerySlidernav = document.querySelector('.js-gallery-nav');
          if (gallerySlidernav) {
            var sliderItemss = new window.Flickity(gallerySlidernav, {
              asNavFor: document.querySelector('.js-gallery'),
              imagesLoaded: true,
              prevNextButtons: false,
              pageDots: false,
              wrapAround: false,
              autoPlay: false,
              contain: true,
              cellAlign: 'left'
            });
            sliderItemss.resize();
          }
          var gallerySlider = document.querySelector('.js-gallery');
          if (gallerySlider) {
            var sliderItems = new window.Flickity(gallerySlider, {

              //            asNavFor: document.querySelector('.js-gallery-nav'),
              imagesLoaded: true,
              prevNextButtons: true,
              pageDots: true,
              wrapAround: false,
              autoPlay: false,
              contain: true,
              cellAlign: 'left'
            });
            sliderItems.resize();
            var flickityNext = document.querySelector('.js-gallery .flickity-prev-next-button.next');
            var flickityPrev = document.querySelector('.js-gallery .flickity-prev-next-button.previous');
            if (flickityNext) {
              flickityNext.appendChild(arrowGallery());
            }
            if (flickityPrev) {
              flickityPrev.appendChild(arrowGallery());
            }
          }
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;

      // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }

    preventVariantURLSwitching() {
      const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
      if (!variantPicker) return;

      variantPicker.setAttribute('data-update-url', 'false');
    }

    removeDOMElements() {
      const pickupAvailability = this.productElement.querySelector('pickup-availability');
      if (pickupAvailability) pickupAvailability.remove();

      const productModal = this.productElement.querySelector('product-modal');
      if (productModal) productModal.remove();

      const modalDialog = this.productElement.querySelectorAll('modal-dialog');
      if (modalDialog) modalDialog.forEach(modal => modal.remove());
    }

    preventDuplicatedIDs() {
      const sectionId = this.productElement.dataset.section;
      this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
      this.productElement.querySelectorAll('variant-selects, variant-radios, product-info').forEach((element) => {
        element.dataset.originalSection = sectionId;
      });
    }

    removeGalleryListSemantic() {
      const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
      if (!galleryList) return;

      galleryList.setAttribute('role', 'presentation');
      galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
    }

    updateImageSizes() {
      const product = this.modalContent.querySelector('.product');
      const desktopColumns = product.classList.contains('product--columns');
      if (!desktopColumns) return;

      const mediaImages = product.querySelectorAll('.product__media img');
      if (!mediaImages.length) return;

      let mediaImageSizes = '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';
      
      if (product.classList.contains('product--medium')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '605px');
      } else if (product.classList.contains('product--small')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '495px');
      }

      mediaImages.forEach(img => img.setAttribute('sizes', mediaImageSizes));
    }
  });
}
